module.exports = __webpack_public_path__ + "img/yes-button.fa0a21f8.png";